import axios from "axios"

export default {
	namespaced: true,
	state: {
		deleting: false,
		restoring: false,
		school: undefined,
		schools: {
			array: [],
			count: 0
		},
		pagination: { size: 50, offset: 0 }
	},
	getters: {
		deleting: state => state.deleting,
		restoring: state => state.restoring,
		school: state => state.school,
		schools: state => state.schools,
		pagination: state => state.pagination
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		},
		LOAD(state, payload) {
			state.schools = payload
		}
	},

	actions: {
		doMutate({ commit }, payload) {
			commit("mutate", payload)
			return true
		},

		doSchools({ commit }, payload) {
			axios
				.post(process.env.VUE_APP_API_URL + "/api/organizations/filters", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					commit("LOAD", res.data)
				})
				.catch(err => {
					console.error(err)
				})
		},

		async doSchoolGetById({ commit }, id) {
			var r = undefined
			await axios
				.get(process.env.VUE_APP_API_URL + "/api/organizations/" + id, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					r = res.data
					commit("mutate", { element: "school", value: res.data })
				})
				.catch(err => {
					console.error(err)
				})

			return r
		},

		doArchive({ commit }, s) {
			const ids = [s.id]
			axios
				.delete(process.env.VUE_APP_API_URL + "/api/organizations", {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") },
					data: { ids }
				})
				.catch(err => {
					console.error(err)
				})
		},
		doRestore({ commit }, s) {
			const ids = [s.id]
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/organizations/restore",
					{ ids },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.catch(err => {
					console.error(err)
				})
		}
	}
}
